module.exports = __webpack_public_path__ + "assets/img/lClass2.79efb0ac.png";